import type { FieldError } from "./field-definitions.logic.ts";
import type { FieldDefinitionDto } from "./field-definitions.schema.ts";

export function isValidUrlString(value: string): boolean {
  try {
    const parsed = new URL(value);
    return parsed.protocol === "https:" || parsed.protocol === "http:";
  } catch {
    return false;
  }
}

export function validateUrl(
  def: FieldDefinitionDto,
  value: unknown,
): FieldError[] {
  if (typeof value !== "string") {
    return [{ fieldName: def.name, message: `${def.label} must be a string` }];
  }
  if (!isValidUrlString(value)) {
    return [
      { fieldName: def.name, message: `${def.label} must be a valid URL` },
    ];
  }
  return [];
}

export function validateUrlList(
  def: FieldDefinitionDto,
  value: unknown,
): FieldError[] {
  if (!Array.isArray(value)) {
    return [
      { fieldName: def.name, message: `${def.label} must be an array of URLs` },
    ];
  }
  for (const item of value) {
    if (typeof item !== "string" || !isValidUrlString(item)) {
      return [
        { fieldName: def.name, message: `${def.label} must be a valid URL` },
      ];
    }
  }
  return [];
}
